import script from "./SlideOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlideOption.vue?vue&type=script&setup=true&lang=ts"

import "./SlideOption.vue?vue&type=style&index=0&id=529a47f4&scoped=true&lang=scss"

import exportComponent from "/builds/kligmanbb/medsafe-smart-pro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529a47f4"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';import TouchSwipe from 'quasar/src/directives/TouchSwipe.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});qInstall(script, 'directives', {TouchSwipe});
